import { status as appointmentStatuses } from '@spike/appointment-model';
import {
    AppointmentsListStatus,
    countByServiceCategoryThunk,
    countPendingThunk,
    countIssueThunk,
    countThunk,
    fetchBoardingMetricsThunk,
    fetchIssuesThunk,
    fetchPendingsThunk,
    fetchThunk,
    GroomingsFilter,
    setSearchThunk,
    fetchBoardingCheckedInThunk,
    countBoardingCheckedInThunk,
    ServiceLocation
} from '@spike/appointments-list-action';
import {
    AppointmentListItem,
    BackendTabCount,
    Metric,
    ServiceCategoryCount,
    StaffListItem,
    StatusCount
} from '@spike/appointments-list-model';
import {
    AppointmentsStatus,
    BookingsStatus,
    bulkUpdateRoomUnitAppointmentsThunk,
    bulkUpdateStatusAppointmentsThunk,
    changeAppointmentRoomUnitThunk
} from '@spike/bookings-action';
import { Client as ClientModel } from '@spike/client-model';
import { OWNER_ID, Period, Sort } from '@spike/model';
import { Pet as PetModel } from '@spike/pet-model';
import useNonInitialEffect from '@versiondos/hooks';
import clsx from 'clsx';
import Checkout from 'components/Checkout2';
import BookingActivityLog from 'components/Bookings2/BookingActivityLog';
import OrderDetail from 'components/OrderDetail';
import PetCard from 'components/PetCard';
import { OverDetail, OverFullWindow } from 'components/UI';
import CreateBookingDrawer from 'components/UI/CreateBookingDrawer';
import PopUpCancelAppointment from 'components/UI/PopUpCanceAppointment';
import { reasonNoShowId } from 'components/UI/PopUpCancelBooking';
import { useApiClientWrapper, useAuth, useMasterData, usePermissions, useTimeZone } from 'hooks';
import moment from 'moment-timezone';
import Client from 'pages/Client';
import { FunctionComponent, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { BookingsDaycarePath, BookingsKanbanPath } from 'routes/Paths';
import { RootState } from 'store';
import styles from './AppointmentsList.module.scss';
import AppointmentsListHeader from './AppointmentsListHeader';
import AppointmentsListTable, { Pagination } from './AppointmentsListTable';
import { DAYCARE_KANBAN_SCROLLER_ID, KanbanBookings } from 'components/Bookings2/Daycare/Kanban/KanbanBookings';
import KanbanMoveDestinationMenu from 'components/Bookings2/Daycare/Kanban/KanbanMoveDestinationMenu';
import {
    readDaycareBookingsView,
    saveDaycareBookingsView
} from 'components/Bookings2/Daycare/Kanban/daycareViewStorage';
import BulkActionsToolbar from './BulkActions/BulkActionsToolbar';
import BulkChangeStatusConfirmDialog from './BulkActions/BulkChangeStatusConfirmDialog';
import { getCommonAvailableActions, getCurrentStatusLabels } from './BulkActions/bulkStatusActions';
import { bookedAtSorter, Sorter, SortOrder } from './sorting';
import { APPOINTMENTS_PAGE_SIZE, defaultServerSortForList, isServerPaginatedList } from './groomingSort';
import {
    boardingArrivalsTab,
    boardingTabs,
    daycareTabs,
    daycareUpcomingTab,
    evaluationsUpcomingTab,
    evaluationTabs,
    getBackendTabsByTabId,
    getServiceCategoryByTabId,
    getStatusIdsByTabId,
    groomingTabs,
    groomingUpcomingTab,
    requestedGroomingTab,
    requestedTabs,
    ServiceCategoryType,
    groomingPendingTab,
    groomingIssueTab,
    allTabs,
    allUpcomingTab,
    allAllTab,
    transportationTabs,
    transportationUpcomingTab,
    trainingTabs,
    trainingUpcomingTab,
    trainingIssueTab,
    trainingPendingTab,
    boardingIssueTab,
    boardingPendingTab,
    daycareIssueTab,
    daycarePendingTab,
    evaluationIssueTab,
    evaluationPendingTab,
    transportationIssueTab,
    transportationPendingTab,
    walkingTabs,
    walkingUpcomingTab,
    walkingIssueTab,
    walkingPendingTab,
    isSessionListType
} from './tabs';
import { CompleteReport, EditReport, ViewReport } from 'components/Reports';
import { BookingsViewData } from 'model/BookingsPath';
import CryptoJS, { AES } from 'crypto-js';
import uniq from 'lodash/uniq';
import { fetchThunk as fetchVehiclesThunk, VehiclesStatus } from '@spike/vehicles-action';
import Analytics from 'analytics/client';
import { Events } from 'analytics/events';
import useOrganizationMarketplaces from 'hooks/useOrganizationMarketplaces';
import { EvaluationReport } from '@spike/report-model';
import { EvaluationReportDrawer } from 'components/UI/EvaluationReportDrawer/EvaluationReportDrawer';
import { fetchStaffThunk } from 'actions/staff/StaffActions';
import { Staff } from 'model/Staff';
import { getWaitlistKeyForListType } from 'components/Waitlist/waitlistUtils';

export type ListType =
    | 'grooming'
    | 'daycare'
    | 'boarding'
    | 'evaluation'
    | 'requested'
    | 'transportation'
    | 'training'
    | 'walking'
    | 'all'
    | 'client';

interface AppointmentsListProps {
    listType: ListType;
    clientId?: number;
    petId?: number;
    scrollableContainerId?: string;
    className?: string;
    fixedDate?: string;
    overlayZIndex?: number;
}

interface Filter extends GroomingsFilter {
    clientId: number | null;
    petId: number | null;
    serviceLocation?: ServiceLocation | null;
}

const fetchDatePattern = 'YYYY/MM/DD';

const getTabsByListType = (listType: ListType) => {
    switch (listType) {
        case 'grooming':
            return [...groomingTabs];
        case 'daycare':
            return [...daycareTabs];
        case 'boarding':
            return [...boardingTabs];
        case 'evaluation':
            return [...evaluationTabs];
        case 'transportation':
            return [...transportationTabs];
        case 'training':
            return [...trainingTabs];
        case 'walking':
            return [...walkingTabs];
        case 'requested':
            return [...requestedTabs];
        case 'all':
            return [...allTabs];
        case 'client':
            return [...allTabs];
        default:
            return [];
    }
};

const getInitialTabByListType = (listType: ListType) => {
    switch (listType) {
        case 'grooming':
            return groomingUpcomingTab;
        case 'daycare':
            return daycareUpcomingTab;
        case 'boarding':
            return boardingArrivalsTab;
        case 'evaluation':
            return evaluationsUpcomingTab;
        case 'transportation':
            return transportationUpcomingTab;
        case 'training':
            return trainingUpcomingTab;
        case 'walking':
            return walkingUpcomingTab;
        case 'requested':
            return requestedGroomingTab;
        case 'all':
            return allUpcomingTab;
        case 'client':
            return allAllTab;
        default:
            return groomingUpcomingTab;
    }
};

const convertHash = (hash?: string): BookingsViewData | null => {
    if (!hash) return null;

    try {
        const json: BookingsViewData = JSON.parse(
            AES.decrypt(decodeURIComponent(hash), `${process.env.REACT_APP_GLOBAL_SECRET}`).toString(CryptoJS.enc.Utf8)
        );

        return json ?? null;
    } catch (error) {
        return null;
    }
};

export const AppointmentsList: FunctionComponent<AppointmentsListProps> = props => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();
    const history = useHistory();
    const routeLocation = useLocation();
    const { organizationMarketplaces, organizationServicesInfo } = useOrganizationMarketplaces();

    const { hash } = useParams<{ hash: string }>();
    const lastHashRef = useRef<string | null>(null);
    const didMountRef = useRef(false);

    const scrollerContainerId = props.scrollableContainerId ?? `appointments-list-container-${props.listType}`;

    const masterData = useMasterData();
    const auth = useAuth();
    const permissions = usePermissions();
    const timezone = useTimeZone();

    // Bulk selection is available on the main service lists (not requested/all/client/evaluation).
    const supportsBulkSelection = ['grooming', 'daycare', 'boarding', 'transportation', 'training', 'walking'].includes(
        props.listType
    );

    const [pagination, setPagination] = useState({ page: 1, pageSize: APPOINTMENTS_PAGE_SIZE });
    const pagingRef = useRef(pagination);

    const [selectedAppointmentIds, setSelectedAppointmentIds] = useState<Set<number>>(new Set());
    const [pendingBulkStatusChange, setPendingBulkStatusChange] = useState<{
        statusId: number;
        statusName: string;
        step: 'summary' | 'cancelation';
    } | null>(null);
    const [pendingRoomMove, setPendingRoomMove] = useState<{
        roomUnitId: number | null;
        label: string;
        appointmentIds?: Array<number>;
    } | null>(null);
    const [moveMenuOpen, setMoveMenuOpen] = useState(false);
    const [movingRooms, setMovingRooms] = useState(false);
    const clearSelection = () => setSelectedAppointmentIds(new Set());

    const isDaycareKanban =
        props.listType === 'daycare' &&
        !hash &&
        (routeLocation.pathname === BookingsKanbanPath ||
            (routeLocation.pathname === BookingsDaycarePath && readDaycareBookingsView() === 'kanban'));

    useEffect(() => {
        if (props.listType !== 'daycare' || hash) {
            return;
        }
        if (routeLocation.pathname === BookingsKanbanPath) {
            if (readDaycareBookingsView() !== 'kanban') {
                saveDaycareBookingsView('kanban');
            }
            return;
        }
        if (routeLocation.pathname === BookingsDaycarePath && readDaycareBookingsView() === 'kanban') {
            history.replace(BookingsKanbanPath);
        }
    }, [props.listType, hash, routeLocation.pathname, history]);

    const list = useSelector<RootState, Array<AppointmentListItem>>(state => {
        switch (props.listType) {
            case 'grooming':
                return state.appointmentsList.groomings.result.page;
            case 'daycare':
                return state.appointmentsList.daycares.result.page;
            case 'boarding':
                return state.appointmentsList.boardings.result.page;
            case 'evaluation':
                return state.appointmentsList.evaluations.result.page;
            case 'transportation':
                return state.appointmentsList.transportations.result.page;
            case 'training':
                return state.appointmentsList.trainings.result.page;
            case 'walking':
                return state.appointmentsList.walkings.result.page;
            case 'requested':
                return state.appointmentsList.requests.result.page;
            case 'all':
                return state.appointmentsList.all.result.page;
            case 'client':
                return state.appointmentsList.client.result.page;
            default:
                return [];
        }
    });

    const boardingMetrics = useSelector<RootState, Array<Metric>>(state => state.appointmentsList.boardings.metrics);

    const filter = useSelector<RootState, Filter>(state => {
        switch (props.listType) {
            case 'grooming':
                return {
                    ...state.appointmentsList.groomings.filter,
                    clientId: null,
                    petId: null
                };
            case 'daycare':
                return {
                    ...state.appointmentsList.daycares.filter,
                    staff: [],
                    clientId: null,
                    petId: null
                };
            case 'boarding':
                return {
                    ...state.appointmentsList.boardings.filter,
                    statusIds: [],
                    serviceCategory: null,
                    staff: [],
                    clientId: null,
                    petId: null
                };
            case 'evaluation':
                return {
                    ...state.appointmentsList.evaluations.filter,
                    roomUnitIds: [],
                    staff: [],
                    clientId: null,
                    petId: null
                };
            case 'transportation':
                return {
                    ...state.appointmentsList.transportations.filter,
                    roomUnitIds: [],
                    staff: [],
                    clientId: null,
                    petId: null
                };
            case 'training':
                return {
                    ...state.appointmentsList.trainings.filter,
                    roomUnitIds: [],
                    clientId: null,
                    petId: null
                };
            case 'walking':
                return {
                    ...state.appointmentsList.walkings.filter,
                    roomUnitIds: [],
                    clientId: null,
                    petId: null
                };
            case 'requested':
                return {
                    ...state.appointmentsList.requests.filter,
                    roomUnitIds: [],
                    staff: [],
                    clientId: null,
                    petId: null
                };
            case 'all':
                return {
                    ...state.appointmentsList.all.filter,
                    staff: [],
                    clientId: null,
                    petId: null
                };
            case 'client':
                return {
                    ...state.appointmentsList.client.filter,
                    staff: [],
                    clientId: null,
                    petId: null
                };
            default:
                return {
                    roomUnitIds: [],
                    staff: [],
                    statusIds: [],
                    from: moment().format('YYYY-MM-DD'),
                    to: moment().format('YYYY-MM-DD'),
                    calendarSelection: 'Today',
                    search: '',
                    sort: null,
                    tabId: null,
                    serviceCategory: null,
                    clientId: null,
                    petId: null,
                    marketplaceIds: [],
                    page: 1,
                    pageSize: APPOINTMENTS_PAGE_SIZE
                };
        }
    });

    const kanbanRoomIds = useMemo(() => {
        const allowedMarketplaceIds = new Set(filter.marketplaceIds);
        const ids = new Set<number>();
        organizationServicesInfo.forEach(info => {
            if (allowedMarketplaceIds.size > 0 && !allowedMarketplaceIds.has(info.marketplace.id)) {
                return;
            }
            [...(info.rooms?.daycare ?? []), ...(info.rooms?.boarding ?? [])].forEach(room => ids.add(room.id));
        });
        return Array.from(ids);
    }, [filter.marketplaceIds, organizationServicesInfo]);

    const countByStatus = useSelector<RootState, Array<StatusCount>>(state => {
        switch (props.listType) {
            case 'grooming':
                return state.appointmentsList.groomings.countByStatus;
            case 'daycare':
                return state.appointmentsList.daycares.countByStatus;
            case 'evaluation':
                return state.appointmentsList.evaluations.countByStatus;
            case 'transportation':
                return state.appointmentsList.transportations.countByStatus;
            case 'training':
                return state.appointmentsList.trainings.countByStatus;
            case 'walking':
                return state.appointmentsList.walkings.countByStatus;
            case 'all':
                return state.appointmentsList.all.countByStatus;
            case 'client':
                return state.appointmentsList.client.countByStatus;
            default:
                return [];
        }
    });

    const countPendings = useSelector<RootState, number>(state => {
        switch (props.listType) {
            case 'grooming':
                return state.appointmentsList.groomings.pendingCount;
            case 'daycare':
                return state.appointmentsList.daycares.pendingCount;
            case 'boarding':
                return state.appointmentsList.boardings.pendingCount;
            case 'evaluation':
                return state.appointmentsList.evaluations.pendingCount;
            case 'transportation':
                return state.appointmentsList.transportations.pendingCount;
            case 'walking':
                return state.appointmentsList.walkings.pendingCount;
            case 'training':
                return state.appointmentsList.trainings.pendingCount;
            default:
                return 0;
        }
    });

    const countIssues = useSelector<RootState, number>(state => {
        switch (props.listType) {
            case 'grooming':
                return state.appointmentsList.groomings.issueCount;
            case 'daycare':
                return state.appointmentsList.daycares.issueCount;
            case 'boarding':
                return state.appointmentsList.boardings.issueCount;
            case 'evaluation':
                return state.appointmentsList.evaluations.issueCount;
            case 'transportation':
                return state.appointmentsList.transportations.issueCount;
            case 'training':
                return state.appointmentsList.trainings.issueCount;
            case 'walking':
                return state.appointmentsList.walkings.issueCount;
            default:
                return 0;
        }
    });

    const countCheckedIn = useSelector<RootState, number>(state => {
        return state.appointmentsList.boardings.checkedInCount;
    });

    const tabs = getTabsByListType(props.listType).filter(
        tab =>
            ['requested', 'all', 'client'].includes(props.listType) ||
            ![
                groomingIssueTab.id,
                groomingPendingTab.id,
                boardingIssueTab.id,
                boardingPendingTab.id,
                daycareIssueTab.id,
                daycarePendingTab.id,
                evaluationIssueTab.id,
                evaluationPendingTab.id,
                transportationIssueTab.id,
                transportationPendingTab.id,
                trainingIssueTab.id,
                trainingPendingTab.id,
                walkingIssueTab.id,
                walkingPendingTab.id
            ].includes(tab.id) ||
            ([
                groomingPendingTab.id,
                boardingPendingTab.id,
                daycarePendingTab.id,
                evaluationPendingTab.id,
                transportationPendingTab.id,
                trainingPendingTab.id,
                walkingPendingTab.id
            ].includes(tab.id) &&
                countPendings > 0) ||
            ([
                groomingIssueTab.id,
                boardingIssueTab.id,
                daycareIssueTab.id,
                evaluationIssueTab.id,
                transportationIssueTab.id,
                trainingIssueTab.id,
                walkingIssueTab.id
            ].includes(tab.id) &&
                countIssues > 0)
    );

    const countByServiceCategory = useSelector<RootState, Array<ServiceCategoryCount>>(state => {
        switch (props.listType) {
            case 'requested':
                return state.appointmentsList.requests.countByServiceCategory;
            default:
                return [];
        }
    });

    const countByBackendTabs = useSelector<RootState, Array<BackendTabCount>>(state => {
        switch (props.listType) {
            case 'boarding':
                return state.appointmentsList.boardings.countByBackendTab;
            default:
                return [];
        }
    });

    const vehiclesStatus = useSelector<RootState, VehiclesStatus>(state => state.vehicles.status);
    const onboardingBookingDone = useSelector<RootState, boolean>(
        state => state.onboardingSteps.onboardingSteps.bookingDone ?? false
    );
    const marketplaceId = useSelector<RootState, number | undefined>(state => state.marketplace.marketplace?.id);
    const marketplaceStaff = useSelector<RootState, Array<Staff>>(state => state.staff.staff);

    const [loading, setLoading] = useState({
        list: true,
        count: true,
        countPendings: [
            'grooming',
            'boarding',
            'daycare',
            'evaluation',
            'transportation',
            'training',
            'walking'
        ].includes(props.listType),
        countIssues: [
            'grooming',
            'boarding',
            'daycare',
            'evaluation',
            'transportation',
            'training',
            'walking'
        ].includes(props.listType),
        countCheckedIn: 'boarding' === props.listType,
        metrics: false,
        vehicles: props.listType === 'transportation'
    });
    const [search, setSearch] = useState(filter.search as string);
    const searchRef = useRef(search);

    const serverPaginationInfo = useSelector<RootState, { totalPages: number; totalRecords: number }>(state => {
        const paginationByList = (() => {
            switch (props.listType) {
                case 'grooming':
                    return state.appointmentsList.groomings.result.pagination;
                case 'daycare':
                    return state.appointmentsList.daycares.result.pagination;
                case 'boarding':
                    return state.appointmentsList.boardings.result.pagination;
                case 'evaluation':
                    return state.appointmentsList.evaluations.result.pagination;
                case 'transportation':
                    return state.appointmentsList.transportations.result.pagination;
                case 'training':
                    return state.appointmentsList.trainings.result.pagination;
                case 'walking':
                    return state.appointmentsList.walkings.result.pagination;
                case 'requested':
                    return state.appointmentsList.requests.result.pagination;
                case 'all':
                    return state.appointmentsList.all.result.pagination;
                case 'client':
                    return state.appointmentsList.client.result.pagination;
                default:
                    return null;
            }
        })();

        return {
            totalPages: paginationByList?.totalPages ?? 0,
            totalRecords: paginationByList?.totalRecords ?? 0
        };
    });

    const [serviceCategories, setServiceCategories] = useState<Array<string>>([]);

    const defaultSorter: Sorter = {
        ...bookedAtSorter,
        order: props.listType === 'client' ? SortOrder.DESCENDING : SortOrder.ASCENDING
    };

    const [sorter, setSorter] = useState<Sorter | null>(defaultSorter);
    const [serverSort, setServerSort] = useState<Sort>(defaultServerSortForList(props.listType));
    const serverSortRef = useRef(serverSort);
    const usesServerPagination = isServerPaginatedList(props.listType);
    const [appliedRoomUnitIds, setAppliedRoomUnitIds] = useState<Array<number>>(filter.roomUnitIds);
    const appliedRoomUnitIdsKey = filter.roomUnitIds.join(',');

    useEffect(() => {
        setAppliedRoomUnitIds(filter.roomUnitIds);
    }, [appliedRoomUnitIdsKey]);

    const appointmentsListStatus = useSelector<RootState, AppointmentsListStatus>(
        state => state.appointmentsList.status
    );

    const appointmentsStatus = useSelector<RootState, AppointmentsStatus>(state => state.appointments.status);
    const bookingsStatus = useSelector<RootState, BookingsStatus>(state => state.bookings.status);

    const filteredAndSortedList = useMemo(() => {
        if (usesServerPagination) {
            const page =
                props.listType !== 'client' || serviceCategories.length === 0
                    ? list
                    : list.filter(app => serviceCategories.includes(app.service.businessArea));

            return page.filter(
                app => appliedRoomUnitIds.length === 0 || appliedRoomUnitIds.includes(app.room?.unit.id ?? 0)
            );
        }

        const tokens = search.toLowerCase().split(' ');
        const filterStaffIds = filter.staff.map(member => member.id);
        const result = list
            .filter(app =>
                tokens.some(
                    token =>
                        app.customer.firstName.toLowerCase().startsWith(token) ||
                        app.customer.lastName.toLowerCase().startsWith(token) ||
                        app.pet.name.toLowerCase().startsWith(token)
                )
            )
            .filter(app => appliedRoomUnitIds.length === 0 || appliedRoomUnitIds.includes(app.room?.unit.id ?? 0))
            .filter(app => filter.staff.length === 0 || filterStaffIds.includes(app.staff?.id ?? 0))
            .filter(
                app =>
                    props.listType !== 'client' ||
                    serviceCategories.length === 0 ||
                    serviceCategories.includes(app.service.businessArea)
            );
        const activeSorter = sorter ?? defaultSorter;
        return activeSorter.sort(result, activeSorter.order);
    }, [search, list, filter, sorter, props.listType, serviceCategories, usesServerPagination, appliedRoomUnitIds]);

    const selectedAppointments = useMemo(
        () => filteredAndSortedList.filter(app => selectedAppointmentIds.has(app.appointmentId)),
        [filteredAndSortedList, selectedAppointmentIds]
    );

    const roomMoveAppointments = useMemo(() => {
        if (!pendingRoomMove?.appointmentIds) {
            return selectedAppointments;
        }
        const ids = new Set(pendingRoomMove.appointmentIds);
        return filteredAndSortedList.filter(app => ids.has(app.appointmentId));
    }, [filteredAndSortedList, pendingRoomMove, selectedAppointments]);

    const bulkTransitionContext = useMemo(
        () => ({
            isOwner: auth.user?.role?.id === OWNER_ID,
            reopenClosedBookings: permissions.checkout.reopenClosedBookings,
            now: moment.tz(timezone)
        }),
        [auth.user?.role?.id, permissions.checkout.reopenClosedBookings, timezone]
    );

    const commonBulkStatusActions = useMemo(
        () =>
            supportsBulkSelection
                ? getCommonAvailableActions(selectedAppointments, masterData, bulkTransitionContext)
                : [],
        [supportsBulkSelection, selectedAppointments, masterData, bulkTransitionContext]
    );

    const selectedAppointmentsCurrentStatusLabels = useMemo(
        () => getCurrentStatusLabels(selectedAppointments),
        [selectedAppointments]
    );

    const [showCheckout, setShowCheckout] = useState<{
        bookingId: number;
        orderId?: number;
        backToOrder: boolean;
        hide: boolean;
    } | null>(null);
    const [showOrder, setShowOrder] = useState<{
        bookingId: number;
        orderId?: number;
        startInEditMode?: boolean;
    } | null>(null);
    const [rightPanelView, setRightPanelView] = useState<'booking_detail' | 'activity_log'>('booking_detail');
    const [showClient, setShowClient] = useState<{ clientId?: number; isNewBooking: boolean; show: boolean }>({
        show: false,
        isNewBooking: false
    });
    const [showPet, setShowPet] = useState<{ petId: number } | null>(null);
    const [showNewBooking, setShowNewBooking] = useState<{
        show: boolean;
        type: 'booking' | 'evaluation' | 'fastCheckIn';
        savedClientId?: number;
        savedPetId?: number;
    }>({ show: false, type: 'booking' });
    const [evaluationReportToView, setEvaluationReportToView] = useState<EvaluationReport | null>(null);

    const [addReport, setAddReport] = useState<{
        appointmentId: number;
        businessArea: string;
        clientHasEmail: boolean;
    } | null>(null);
    const [viewReport, setViewReport] = useState<{
        appointmentId: number;
        businessArea: string;
        clientHasEmail: boolean;
    } | null>(null);
    const [editReport, setEditReport] = useState<{
        appointmentId: number;
        businessArea: string;
        clientHasEmail: boolean;
    } | null>(null);

    const refetch = () => {
        const serviceCategory = getServiceCategoryByTabId(filter.tabId);
        serviceCategory &&
            fetch(
                serviceCategory,
                filter.tabId,
                filter.marketplaceIds,
                filter.from,
                filter.to,
                filter.calendarSelection,
                appliedRoomUnitIds,
                filter.staff,
                props.clientId || null,
                props.petId || null
            );
    };

    const DAYCARE_KANBAN_PAGE_SIZE = 99999;

    const fetch = (
        serviceCategory: ServiceCategoryType,
        tabId: string | null,
        marketplaceIds: Array<number>,
        from: string | null,
        to: string | null,
        calendarSelectiomId: string | null,
        roomUnitIds: Array<number>,
        staff: Array<StaffListItem>,
        clientId: number | null,
        petId: number | null,
        serviceLocationFilter: ServiceLocation | null = filter.serviceLocation ?? null
    ) => {
        setLoading(prev => ({ ...prev, list: true }));

        const selectedMarketplaceIds =
            marketplaceIds.length === 0
                ? organizationMarketplaces.map(marketplace => marketplace.id)
                : [...marketplaceIds];

        const query = usesServerPagination
            ? {
                  sort: serverSortRef.current,
                  search: encodeURIComponent(searchRef.current),
                  page: isDaycareKanban ? 1 : pagingRef.current.page,
                  pageSize: isDaycareKanban ? DAYCARE_KANBAN_PAGE_SIZE : pagingRef.current.pageSize
              }
            : {
                  sort: null,
                  search: '',
                  page: 1,
                  pageSize: 100
              };

        if (
            ['grooming', 'boarding', 'daycare', 'evaluation', 'transportation', 'training', 'walking'].includes(
                props.listType
            ) &&
            [
                'grooming_pending',
                'daycare_pending',
                'boarding_pending',
                'evaluation_pending',
                'transportation_pending',
                'training_pending',
                'walking_pending'
            ].includes(tabId ?? '')
        ) {
            dispatch(
                fetchPendingsThunk(
                    apiClientWrapper,
                    props.listType,
                    serviceCategory,
                    selectedMarketplaceIds,
                    from,
                    to,
                    tabId,
                    calendarSelectiomId,
                    staff,
                    query.sort,
                    query.search,
                    query.page,
                    query.pageSize
                )
            );
        } else if (
            ['grooming', 'boarding', 'daycare', 'evaluation', 'transportation', 'training', 'walking'].includes(
                props.listType
            ) &&
            [
                'grooming_issue',
                'daycare_issue',
                'boarding_issue',
                'evaluation_issue',
                'transportation_issue',
                'training_issue',
                'walking_issue'
            ].includes(tabId ?? '')
        ) {
            dispatch(
                fetchIssuesThunk(
                    apiClientWrapper,
                    props.listType,
                    serviceCategory,
                    selectedMarketplaceIds,
                    from,
                    to,
                    tabId,
                    calendarSelectiomId,
                    staff,
                    query.sort,
                    query.search,
                    query.page,
                    query.pageSize
                )
            );
        } else if (props.listType === 'boarding' && tabId === 'boarding_checked_in') {
            dispatch(
                fetchBoardingCheckedInThunk(
                    apiClientWrapper,
                    serviceCategory,
                    marketplaceIds,
                    from,
                    to,
                    tabId,
                    calendarSelectiomId,
                    roomUnitIds,
                    query.sort,
                    query.search,
                    query.page,
                    query.pageSize
                )
            );
        } else {
            dispatch(
                fetchThunk(
                    apiClientWrapper,
                    props.listType,
                    serviceCategory,
                    selectedMarketplaceIds,
                    tabId,
                    from,
                    to,
                    calendarSelectiomId,
                    getStatusIdsByTabId(tabId),
                    roomUnitIds,
                    getBackendTabsByTabId(tabId),
                    staff,
                    clientId,
                    petId,
                    query.sort,
                    query.search,
                    query.page,
                    query.pageSize,
                    serviceLocationFilter
                )
            );
        }
        count(
            serviceCategory,
            selectedMarketplaceIds,
            from,
            to,
            roomUnitIds,
            staff.map(member => member.id),
            clientId,
            petId,
            serviceLocationFilter
        );
        if (props.listType === 'boarding') {
            fetchBoardingMetrics(selectedMarketplaceIds, from, to);
        }
    };

    const count = (
        serviceCategory: ServiceCategoryType,
        marketplaceIds: Array<number>,
        from: string | null,
        to: string | null,
        roomUnitIds: Array<number>,
        staffIds: Array<number>,
        clientId: number | null,
        petId: number | null,
        serviceLocationFilter: ServiceLocation | null = filter.serviceLocation ?? null
    ) => {
        setLoading(prev => ({ ...prev, count: props.listType !== 'boarding' }));

        const selectedMarketplaceIds =
            marketplaceIds.length === 0
                ? organizationMarketplaces.map(marketplace => marketplace.id)
                : [...marketplaceIds];

        if (props.listType === 'requested') {
            dispatch(
                countByServiceCategoryThunk(
                    apiClientWrapper,
                    selectedMarketplaceIds,
                    from,
                    to,
                    [appointmentStatuses.REQUESTED],
                    roomUnitIds,
                    staffIds
                )
            );
        } else if (props.listType !== 'boarding') {
            dispatch(
                countThunk(
                    apiClientWrapper,
                    props.listType,
                    serviceCategory,
                    selectedMarketplaceIds,
                    from,
                    to,
                    [],
                    roomUnitIds,
                    staffIds,
                    clientId,
                    petId,
                    serviceLocationFilter
                )
            );
        }

        if (!['requested', 'all', 'client'].includes(props.listType)) {
            setLoading(prev => ({ ...prev, countPendings: true, countIssues: true }));
            dispatch(countPendingThunk(apiClientWrapper, props.listType, serviceCategory, selectedMarketplaceIds));
            dispatch(countIssueThunk(apiClientWrapper, props.listType, serviceCategory, selectedMarketplaceIds));
        }

        if (props.listType === 'boarding') {
            setLoading(prev => ({ ...prev, countCheckedIn: true }));
            dispatch(countBoardingCheckedInThunk(apiClientWrapper, marketplaceIds, roomUnitIds));
        }
    };

    const fetchBoardingMetrics = (marketplaceIds: Array<number>, from: string | null, to: string | null) => {
        const selectedMarketplaceIds =
            marketplaceIds.length === 0
                ? organizationMarketplaces.map(marketplace => marketplace.id)
                : [...marketplaceIds];

        setLoading(prev => ({ ...prev, metrics: true }));
        dispatch(fetchBoardingMetricsThunk(apiClientWrapper, selectedMarketplaceIds, from, to));
    };

    useEffect(() => {
        if (location.href.indexOf('bookings') > -1 && hash !== null && lastHashRef.current !== hash) {
            lastHashRef.current = hash;
            setRightPanelView('booking_detail');
            setShowOrder(convertHash(hash));
        }
    }, [hash]);

    // When a notification is opened while already viewing this module (no remount,
    // only the hash changes), switch to the booking's status tab carried in the
    // `tab` query param. The initial mount is handled by the fetch effect (SU-2165).
    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }

        const requestedTabId = new URLSearchParams(location.search).get('tab');
        if (requestedTabId && requestedTabId !== filter.tabId && getServiceCategoryByTabId(requestedTabId)) {
            changeTabHandler(requestedTabId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hash]);

    useEffect(() => {
        const initialTab = getInitialTabByListType(props.listType);
        // When opened from a notification the destination tab travels as a `tab`
        // query param so the list lands on the booking's actual status tab (SU-2165).
        const requestedTabId = new URLSearchParams(location.search).get('tab');
        const tabId = requestedTabId && getServiceCategoryByTabId(requestedTabId) ? requestedTabId : initialTab.id;
        const serviceCategory = getServiceCategoryByTabId(tabId) ?? initialTab.serviceCategory;

        const initialDate = props.fixedDate
            ? moment(props.fixedDate, 'YYYY-MM-DD').format(fetchDatePattern)
            : moment().format(fetchDatePattern);
        fetch(
            serviceCategory,
            tabId,
            organizationMarketplaces.map(marketplace => marketplace.id),
            props.listType === 'client' ? null : initialDate,
            props.listType === 'client' ? null : initialDate,
            props.listType === 'client' ? 'All Time' : props.fixedDate ? null : 'Today',
            [],
            [],
            props.clientId ?? null,
            props.petId ?? null
        );
    }, []);

    useNonInitialEffect(() => {
        clearSelection();
        searchRef.current = filter.search;
        setSearch(filter.search);
        const nextServerSort = defaultServerSortForList(props.listType);
        serverSortRef.current = nextServerSort;
        setServerSort(nextServerSort);
        setSorter({
            ...bookedAtSorter,
            order: props.listType === 'client' ? SortOrder.DESCENDING : SortOrder.ASCENDING
        });
        setFirstPage();

        const tabId = filter.tabId ?? getInitialTabByListType(props.listType).id;

        fetch(
            getServiceCategoryByTabId(filter.tabId) ?? getInitialTabByListType(props.listType).serviceCategory,
            tabId,
            filter.marketplaceIds,
            filter.from,
            filter.to,
            filter.calendarSelection,
            appliedRoomUnitIds,
            filter.staff,
            props.clientId || null,
            props.petId || null
        );
    }, [props.listType]);

    useEffect(() => {
        if (isSessionListType(props.listType)) {
            dispatch(fetchStaffThunk());
        }
    }, [props.listType]);

    useEffect(() => {
        if (props.listType === 'transportation') {
            setLoading(prev => ({ ...prev, vehicles: true }));
            dispatch(
                fetchVehiclesThunk(
                    apiClientWrapper,
                    Array.from(apiClientWrapper.organizationMarceplaces.values()).map(om => om.id)
                )
            );
        }
    }, [props.listType]);

    useNonInitialEffect(() => {
        switch (vehiclesStatus) {
            case VehiclesStatus.FetchSuccess:
            case VehiclesStatus.Error:
                setLoading(prev => ({ ...prev, vehicles: false }));
        }
    }, [vehiclesStatus]);

    useNonInitialEffect(() => {
        switch (appointmentsListStatus) {
            case AppointmentsListStatus.GroomingsFetchSuccess:
            case AppointmentsListStatus.GroomingsPendingFetchSuccess:
            case AppointmentsListStatus.GroomingsIssueFetchSuccess:
            case AppointmentsListStatus.DaycaresPendingFetchSuccess:
            case AppointmentsListStatus.DaycaresIssueFetchSuccess:
            case AppointmentsListStatus.BoardingsPendingFetchSuccess:
            case AppointmentsListStatus.BoardingsIssueFetchSuccess:
            case AppointmentsListStatus.EvaluationsPendingFetchSuccess:
            case AppointmentsListStatus.EvaluationsIssueFetchSuccess:
            case AppointmentsListStatus.TransportationsPendingFetchSuccess:
            case AppointmentsListStatus.TransportationsIssueFetchSuccess:
            case AppointmentsListStatus.TrainingsPendingFetchSuccess:
            case AppointmentsListStatus.TrainingsIssueFetchSuccess:
            case AppointmentsListStatus.WalkingsPendingFetchSuccess:
            case AppointmentsListStatus.WalkingsIssueFetchSuccess:
            case AppointmentsListStatus.DaycaresFetchSuccess:
            case AppointmentsListStatus.BoardingsFetchSuccess:
            case AppointmentsListStatus.EvaluationsFetchSuccess:
            case AppointmentsListStatus.TransportationsFetchSuccess:
            case AppointmentsListStatus.TrainingsFetchSuccess:
            case AppointmentsListStatus.WalkingsFetchSuccess:
            case AppointmentsListStatus.RequestsFetchSuccess:
            case AppointmentsListStatus.AllFetchSuccess:
            case AppointmentsListStatus.ClientFetchSuccess:
            case AppointmentsListStatus.BoardingsCheckedInFetchSuccess:
                setLoading(prev => ({ ...prev, list: false }));
                break;
            case AppointmentsListStatus.GroomingsCountSuccess:
            case AppointmentsListStatus.DaycaresCountSuccess:
            case AppointmentsListStatus.EvaluationsCountSuccess:
            case AppointmentsListStatus.TransportationsCountSuccess:
            case AppointmentsListStatus.TrainingsCountSuccess:
            case AppointmentsListStatus.WalkingsCountSuccess:
            case AppointmentsListStatus.RequestsCountSuccess:
            case AppointmentsListStatus.AllCountSuccess:
            case AppointmentsListStatus.ClientCountSuccess:
                setLoading(prev => ({ ...prev, count: false }));
                break;
            case AppointmentsListStatus.GroomingsPendingCountSuccess:
            case AppointmentsListStatus.DaycaresPendingCountSuccess:
            case AppointmentsListStatus.BoardingsPendingCountSuccess:
            case AppointmentsListStatus.EvaluationsPendingCountSuccess:
            case AppointmentsListStatus.TransportationsPendingCountSuccess:
            case AppointmentsListStatus.TrainingsPendingCountSuccess:
            case AppointmentsListStatus.WalkingsPendingCountSuccess:
                setLoading(prev => ({ ...prev, countPendings: false }));
                break;
            case AppointmentsListStatus.GroomingsIssueCountSuccess:
            case AppointmentsListStatus.DaycaresIssueCountSuccess:
            case AppointmentsListStatus.BoardingsIssueCountSuccess:
            case AppointmentsListStatus.EvaluationsIssueCountSuccess:
            case AppointmentsListStatus.TransportationsIssueCountSuccess:
            case AppointmentsListStatus.TrainingsIssueCountSuccess:
            case AppointmentsListStatus.WalkingsIssueCountSuccess:
                setLoading(prev => ({ ...prev, countIssues: false }));
                break;
            case AppointmentsListStatus.BoardingsCheckedInCountSuccess:
                setLoading(prev => ({ ...prev, countCheckedIn: false }));
                break;
            case AppointmentsListStatus.BoardingsMetricsFetchSuccess:
                setLoading(prev => ({ ...prev, metrics: false }));
                break;
            case AppointmentsListStatus.GroomingsError:
            case AppointmentsListStatus.DaycaresError:
            case AppointmentsListStatus.BoardingsError:
            case AppointmentsListStatus.EvaluationsError:
            case AppointmentsListStatus.TransportationsError:
            case AppointmentsListStatus.TrainingsError:
            case AppointmentsListStatus.WalkingsError:
            case AppointmentsListStatus.RequestsError:
            case AppointmentsListStatus.AllError:
            case AppointmentsListStatus.ClientError:
                setLoading(prev => ({
                    ...prev,
                    list: false,
                    count: false,
                    countPendings: false,
                    countIssues: false,
                    countCheckedIn: false,
                    metrics: false
                }));
                break;
        }
    }, [appointmentsListStatus]);

    useNonInitialEffect(() => {
        switch (appointmentsStatus) {
            case AppointmentsStatus.ChangeStatusSuccess:
            case AppointmentsStatus.CompleteSuccess:
            case AppointmentsStatus.ChangeRoomUnitSuccess:
                refetch();
                break;
            case AppointmentsStatus.BulkUpdateStatusSuccess:
                setPendingBulkStatusChange(null);
                clearSelection();
                refetch();
                break;
        }
    }, [appointmentsStatus]);

    useNonInitialEffect(() => {
        switch (bookingsStatus) {
            case BookingsStatus.ConfirmAppointmentSuccess:
                refetch();
                break;
        }
    }, [bookingsStatus]);

    const searchHandler = (value: string) => {
        setFirstPage();
        clearSelection();
        searchRef.current = value;
        setSearch(value);
        dispatch(setSearchThunk(props.listType, value));
        if (usesServerPagination) {
            refetch();
        }
    };

    const changePeriodHandler = (period: Period, allTime: boolean, calendarSelection: string | null) => {
        setFirstPage();
        clearSelection();
        const serviceCategory = getServiceCategoryByTabId(filter.tabId);
        serviceCategory &&
            fetch(
                serviceCategory,
                filter.tabId,
                filter.marketplaceIds,
                period.from.format(fetchDatePattern),
                period.to.format(fetchDatePattern),
                calendarSelection,
                appliedRoomUnitIds,
                filter.staff,
                props.clientId || null,
                props.petId || null
            );
    };

    const changeTabHandler = (tabId: string) => {
        setFirstPage();
        clearSelection();
        const serviceCategory = getServiceCategoryByTabId(tabId);
        serviceCategory &&
            fetch(
                serviceCategory,
                tabId,
                filter.marketplaceIds,
                filter.from,
                filter.to,
                filter.calendarSelection,
                appliedRoomUnitIds,
                filter.staff,
                props.clientId || null,
                props.petId || null
            );
    };

    const changeRoomUnitIdsHandler = (roomUnitIds: Array<number>) => {
        setAppliedRoomUnitIds(roomUnitIds);
        setFirstPage();
        clearSelection();
        const serviceCategory = getServiceCategoryByTabId(filter.tabId);
        serviceCategory &&
            fetch(
                serviceCategory,
                filter.tabId,
                filter.marketplaceIds,
                filter.from,
                filter.to,
                filter.calendarSelection,
                roomUnitIds,
                filter.staff,
                props.clientId || null,
                props.petId || null
            );
    };
    const changeStaffHandler = (selectedStaff: Array<StaffListItem>, all: boolean) => {
        setFirstPage();
        clearSelection();
        const serviceCategory = getServiceCategoryByTabId(filter.tabId);
        serviceCategory &&
            fetch(
                serviceCategory,
                filter.tabId,
                filter.marketplaceIds,
                filter.from,
                filter.to,
                filter.calendarSelection,
                appliedRoomUnitIds,
                all ? [] : selectedStaff,
                props.clientId || null,
                props.petId || null
            );
    };

    const changeServiceLocationHandler = (selectedServiceLocation: ServiceLocation | undefined) => {
        setFirstPage();
        clearSelection();
        const serviceCategory = getServiceCategoryByTabId(filter.tabId);
        serviceCategory &&
            fetch(
                serviceCategory,
                filter.tabId,
                filter.marketplaceIds,
                filter.from,
                filter.to,
                filter.calendarSelection,
                appliedRoomUnitIds,
                filter.staff,
                props.clientId || null,
                props.petId || null,
                // null, not undefined: undefined would fall back to the stored location and never clear it
                selectedServiceLocation ?? null
            );
    };

    const changeLocationsHandler = (selectedLocations: Array<number>) => {
        setFirstPage();
        clearSelection();
        const serviceCategory = getServiceCategoryByTabId(filter.tabId);
        serviceCategory &&
            fetch(
                serviceCategory,
                filter.tabId,
                [...selectedLocations],
                filter.from,
                filter.to,
                filter.calendarSelection,
                appliedRoomUnitIds,
                filter.staff,
                props.clientId || null,
                props.petId || null
            );
    };

    const checkoutHandler = (bookingId: number, orderId: number | undefined, backToOrder: boolean) => {
        if (backToOrder) {
            setShowOrder(null);
        }
        setShowCheckout({ bookingId, orderId, backToOrder, hide: false });
    };

    const closeCheckoutHandler = () => {
        if (showCheckout?.backToOrder) {
            const bookingId = showCheckout?.bookingId;
            const orderId = showCheckout?.orderId;

            setShowCheckout(null);
            bookingId && setShowOrder({ bookingId, orderId, startInEditMode: false });
        } else {
            setShowCheckout(null);
        }
    };

    const showOrderHandler = (bookingId: number, orderId?: number, startInEditMode = false) => {
        setRightPanelView('booking_detail');
        setShowOrder({ bookingId, orderId, startInEditMode });
    };

    const closeOrderHandler = () => {
        refetch();
        setRightPanelView('booking_detail');
        setShowOrder(null);
        // Drop the booking hash (and tab param) from the URL when the detail was
        // opened from a notification/deeplink, leaving a clean list path (SU-2165).
        // Other parents, such as the client profile, also have a `:hash` route param.
        if (hash && location.pathname.startsWith('/bookings/')) {
            history.replace(`/bookings/${props.listType}`);
        }
    };

    const closeClientView = () =>
        setShowClient(prev => ({ ...prev, show: false, clientId: undefined, isNewBooking: false }));

    const showClientHandler = (clientId: number) => {
        setShowCheckout(prev => (prev === null ? null : { ...prev, hide: true }));
        setShowClient(prev => ({ ...prev, show: true, clientId, isNewBooking: false }));
    };

    const closeClientHandler = () => {
        closeClientView();
        setShowCheckout(prev => (prev === null ? null : { ...prev, hide: false }));
    };

    const addNewClient = () => {
        setShowNewBooking(prev => ({ ...prev, show: false }));
        setShowClient(prev => ({ ...prev, show: true, clientId: undefined, isNewBooking: false }));
    };

    const savedClientHandler = (savedClient: ClientModel) => {
        refetch();
        closeClientView();
        setShowCheckout(prev => (prev === null ? null : { ...prev, hide: false }));
        setShowNewBooking(prev => ({ ...prev, show: true, savedClientId: savedClient.id, savedPetId: undefined }));
    };

    const addNewPet = (clientId: number) => {
        setShowNewBooking(prev => ({ ...prev, show: false }));
        setShowClient(prev => ({ ...prev, show: true, clientId, isNewBooking: true }));
    };

    const savedClientPetHandler = (savedPet: PetModel) => {
        refetch();
        closeClientView();
        setShowCheckout(prev => (prev === null ? null : { ...prev, hide: false }));
        setShowNewBooking(prev => ({ ...prev, show: true, savedPetId: savedPet.id }));
    };

    const showPetHandler = (petId: number) => {
        setShowPet({ petId });
    };

    const closePetHandler = () => {
        setShowPet(null);
    };

    const savedPetHandler = () => {
        refetch();
        setShowPet(null);
    };

    const getFlowFromListType = (
        lt: ListType
    ): 'grooming' | 'daycare' | 'boarding' | 'transportation' | 'walking' | 'training' | undefined => {
        switch (lt) {
            case 'grooming':
                return 'grooming';
            case 'daycare':
                return 'daycare';
            case 'boarding':
                return 'boarding';
            case 'transportation':
                return 'transportation';
            case 'walking':
                return 'walking';
            case 'training':
                return 'training';
            default:
                return undefined;
        }
    };

    const showNewBookingHandler = (type: 'booking' | 'evaluation' | 'fastCheckIn') => {
        if (type === 'booking' || type === 'fastCheckIn') {
            if (!onboardingBookingDone && marketplaceId) {
                try {
                    const key = `event_one_shot_${Events.CTA_BOOK_APPOINTMENT_CLICKED}_${marketplaceId}`;
                    if (localStorage.getItem(key) !== '1') {
                        Analytics.track(Events.CTA_BOOK_APPOINTMENT_CLICKED as any, {
                            marketplace_id: marketplaceId
                        });
                        localStorage.setItem(key, '1');
                    }
                } catch (e) {
                    // non-blocking
                }
            }
        }
        setShowNewBooking(prev => ({ ...prev, show: true, type, savedClientId: undefined, savedPetId: undefined }));
    };

    const closeNewBookingHandler = () => {
        refetch();
        setShowNewBooking(prev => ({ ...prev, show: false, savedClientId: undefined, savedPetId: undefined }));
    };

    const changeRoomUnitHandler = (appointmentId: number, roomUnitId: number | null) => {
        setFirstPage();
        dispatch(changeAppointmentRoomUnitThunk(apiClientWrapper, appointmentId, roomUnitId));
    };

    const changeBookingsViewHandler = (view: 'kanban' | 'list') => {
        saveDaycareBookingsView(view);
        clearSelection();
        setMoveMenuOpen(false);
        setPendingRoomMove(null);
        history.replace(view === 'kanban' ? BookingsKanbanPath : BookingsDaycarePath);
    };

    const confirmRoomMoveHandler = async () => {
        if (!pendingRoomMove || roomMoveAppointments.length === 0) {
            return;
        }

        setMovingRooms(true);
        try {
            const result = await dispatch(
                bulkUpdateRoomUnitAppointmentsThunk(
                    apiClientWrapper,
                    roomMoveAppointments.map(appointment => appointment.appointmentId),
                    pendingRoomMove.roomUnitId
                )
            );

            if (!result) {
                return;
            }

            const failedIds = new Set((result.failed_appointments ?? []).map(failed => failed.id));
            setSelectedAppointmentIds(failedIds);
            setPendingRoomMove(null);
            setMoveMenuOpen(false);
            refetch();
        } finally {
            setMovingRooms(false);
        }
    };

    const addReportHandler = (appointmentId: number) => {
        const appointmentListItem = list.find(app => app.appointmentId === appointmentId);

        if (appointmentListItem) {
            const customerEmail = appointmentListItem.customer.email ?? '';

            setAddReport({
                appointmentId: appointmentListItem.appointmentId,
                businessArea: appointmentListItem.service.businessArea,
                clientHasEmail: customerEmail.length > 0 && customerEmail.indexOf('temporal') === -1
            });
        }
    };

    const viewReportHandler = (appointmentId: number) => {
        const appointmentListItem = list.find(app => app.appointmentId === appointmentId);

        if (appointmentListItem) {
            setEditReport(null);

            const customerEmail = appointmentListItem.customer.email ?? '';

            setViewReport({
                appointmentId: appointmentListItem.appointmentId,
                businessArea: appointmentListItem.service.businessArea,
                clientHasEmail: customerEmail.length > 0 && customerEmail.indexOf('temporal') === -1
            });
        }
    };

    const editReportHandler = (appointmentId: number) => {
        const appointmentListItem = list.find(app => app.appointmentId === appointmentId);

        if (appointmentListItem) {
            setViewReport(null);

            const customerEmail = appointmentListItem.customer.email ?? '';

            setEditReport({
                appointmentId: appointmentListItem.appointmentId,
                businessArea: appointmentListItem.service.businessArea,
                clientHasEmail: customerEmail.length > 0 && customerEmail.indexOf('temporal') === -1
            });
        }
    };

    const backReportHandler = () => {
        setViewReport(null);
        setEditReport(null);
        setAddReport(null);
    };

    const closeReportHandler = () => {
        setViewReport(null);
        setEditReport(null);
        setAddReport(null);
    };

    const sortHandler = (nextSorter: Sorter | null) => {
        clearSelection();
        setSorter(nextSorter);
    };

    const serverSortHandler = (sort: Sort) => {
        clearSelection();
        serverSortRef.current = sort;
        setServerSort(sort);
        setFirstPage();
        refetch();
    };

    const paginationChangeHandler = (newPagination: Pagination) => {
        clearSelection();
        const next =
            newPagination.pageSize !== pagingRef.current.pageSize ? { ...newPagination, page: 1 } : newPagination;
        pagingRef.current = next;
        setPagination(next);
        if (usesServerPagination) {
            refetch();
        }
    };

    const toggleSelectAppointmentHandler = (appointmentId: number, checked: boolean) => {
        setSelectedAppointmentIds(prev => {
            const next = new Set(prev);
            checked ? next.add(appointmentId) : next.delete(appointmentId);
            return next;
        });
    };

    const toggleSelectAllHandler = (checked: boolean, appointmentIds: Array<number>) => {
        setSelectedAppointmentIds(prev => {
            const next = new Set(prev);
            appointmentIds.forEach(id => (checked ? next.add(id) : next.delete(id)));
            return next;
        });
    };

    const selectBulkStatusHandler = (statusId: number, statusName: string) => {
        setPendingBulkStatusChange({ statusId, statusName, step: 'summary' });
    };

    const cancelBulkStatusChangeHandler = () => {
        if (appointmentsStatus === AppointmentsStatus.BulkUpdatingStatus) {
            return;
        }
        setPendingBulkStatusChange(null);
    };

    const isBulkCancelOrNoShowStatus = (statusId: number) =>
        [appointmentStatuses.CANCELLED, appointmentStatuses.NO_SHOW].includes(statusId);

    const confirmBulkStatusChangeHandler = (
        _appointmentId?: number,
        sendNotification?: boolean,
        cancelationReasonId?: number
    ) => {
        if (!pendingBulkStatusChange || selectedAppointments.length === 0) {
            return;
        }

        const appointmentIds = selectedAppointments.map(app => app.appointmentId);
        const isCancelFlow = isBulkCancelOrNoShowStatus(pendingBulkStatusChange.statusId);

        // Cancel / No Show use the same cancelation flow as a single appointment: status becomes
        // CANCELLED, and No Show is distinguished by the cancelation reason.
        const statusId = isCancelFlow ? appointmentStatuses.CANCELLED : pendingBulkStatusChange.statusId;

        if (isCancelFlow) {
            // Close the cancelation modal immediately, same as the single-appointment StatusButton.
            setPendingBulkStatusChange(null);
        }

        dispatch(
            bulkUpdateStatusAppointmentsThunk(
                apiClientWrapper,
                appointmentIds,
                statusId,
                sendNotification,
                cancelationReasonId
            )
        );
    };

    const confirmBulkSummaryHandler = () => {
        if (!pendingBulkStatusChange) {
            return;
        }

        // Cancel / No Show: after the summary "Yes", open the cancelation modal next.
        if (isBulkCancelOrNoShowStatus(pendingBulkStatusChange.statusId)) {
            setPendingBulkStatusChange(prev => (prev ? { ...prev, step: 'cancelation' } : null));
            return;
        }

        confirmBulkStatusChangeHandler();
    };

    const staffChangeSavedHandler = () => {
        ['grooming_issue', 'transportation_issue', 'training_issue', 'walking_issue'].includes(filter.tabId ?? '') &&
            refetch();
    };

    const setFirstPage = () => {
        const next = { ...pagingRef.current, page: 1 };
        pagingRef.current = next;
        setPagination(next);
    };

    useNonInitialEffect(() => {
        if (props.listType !== 'daycare') {
            return;
        }

        setFirstPage();
        refetch();
    }, [isDaycareKanban]);

    useNonInitialEffect(() => {
        if (!usesServerPagination || loading.list || list.length > 0 || pagingRef.current.page <= 1) {
            return;
        }

        setFirstPage();
        refetch();
    }, [list, loading.list, usesServerPagination]);

    return (
        <>
            <div
                id={scrollerContainerId}
                className={clsx(styles.container, props.className, { [styles.kanbanContainer]: isDaycareKanban })}
            >
                <div className={styles.header}>
                    <AppointmentsListHeader
                        listType={props.listType}
                        appointments={filteredAndSortedList}
                        tabs={tabs}
                        selectedTabId={filter.tabId}
                        period={{
                            from: moment(filter.from ?? '2000-01-01', fetchDatePattern),
                            to: moment(filter.to ?? '2100-01-01', fetchDatePattern)
                        }}
                        calendarSelectionId={filter.calendarSelection}
                        search={search}
                        selectableRoomIds={
                            isDaycareKanban && kanbanRoomIds.length > 0
                                ? kanbanRoomIds
                                : uniq(list.filter(app => app.room !== null).map(app => app.room!.id))
                        }
                        selectedRoomUnitIds={[...appliedRoomUnitIds]}
                        selectableStaff={[
                            ...list.map(app =>
                                app.staff === null ? { id: 0, name: 'Unassigned', imageUrl: null } : app.staff
                            ),
                            // Session areas list every active member so the filter stays usable on days without bookings.
                            ...(isSessionListType(props.listType)
                                ? marketplaceStaff
                                      .filter(member => member.id !== undefined && member.active && !member.deleted)
                                      .map(member => ({
                                          id: member.id!,
                                          name: `${member.person.firstName} ${member.person.lastName}`.trim(),
                                          imageUrl: member.person.avatar || null
                                      }))
                                : [])
                        ].reduce<Array<StaffListItem>>(
                            (list, staff) =>
                                list.some(staffList => staffList.id === staff.id) ? list : [...list, staff],
                            []
                        )}
                        selectedStaff={[...filter.staff]}
                        selectedMarketplaceIds={[...filter.marketplaceIds]}
                        selectedServiceLocation={filter.serviceLocation ?? undefined}
                        onChangeServiceLocation={changeServiceLocationHandler}
                        countByStatus={countByStatus}
                        countByServiceCategory={countByServiceCategory}
                        countByBackendTab={countByBackendTabs}
                        countPendings={countPendings}
                        countIssues={countIssues}
                        countCheckedIn={countCheckedIn}
                        countForSelectedTab={
                            usesServerPagination ? serverPaginationInfo.totalRecords : filteredAndSortedList.length
                        }
                        metrics={props.listType === 'boarding' ? boardingMetrics : []}
                        loading={
                            loading.count ||
                            loading.list ||
                            loading.countPendings ||
                            loading.countIssues ||
                            loading.countCheckedIn
                        }
                        loadingMetrics={loading.metrics}
                        onSearch={searchHandler}
                        onChangePeriod={changePeriodHandler}
                        onChangeTab={changeTabHandler}
                        onChangeRoomUnitIds={changeRoomUnitIdsHandler}
                        onAdd={props.listType === 'client' ? undefined : showNewBookingHandler}
                        bookingsView={props.listType === 'daycare' ? (isDaycareKanban ? 'kanban' : 'list') : undefined}
                        onChangeBookingsView={props.listType === 'daycare' ? changeBookingsViewHandler : undefined}
                        onChangeStaff={changeStaffHandler}
                        onChangeMarketplaces={changeLocationsHandler}
                        onChangeServiceCategories={setServiceCategories}
                        hideDateFilter={props.fixedDate !== undefined}
                        waitlistKey={
                            props.fixedDate === undefined ? getWaitlistKeyForListType(props.listType) : undefined
                        }
                    />
                </div>
                <div
                    id={isDaycareKanban ? DAYCARE_KANBAN_SCROLLER_ID : undefined}
                    className={clsx(styles.body, { [styles.kanbanBody]: isDaycareKanban })}
                >
                    {isDaycareKanban ? (
                        <KanbanBookings
                            appointments={filteredAndSortedList}
                            occupancyAppointments={list}
                            selectedMarketplaceIds={[...filter.marketplaceIds]}
                            loading={loading.list}
                            selectedIds={selectedAppointmentIds}
                            selectableRoomIds={uniq(list.filter(app => app.room !== null).map(app => app.room!.id))}
                            selectedRoomUnitIds={[...appliedRoomUnitIds]}
                            onChangeRoomUnits={(roomUnitIds, all) =>
                                changeRoomUnitIdsHandler(all ? [] : [...roomUnitIds])
                            }
                            onToggleSelect={toggleSelectAppointmentHandler}
                            onToggleSelectAll={toggleSelectAllHandler}
                            onMoveUnit={appointmentIds => {
                                setSelectedAppointmentIds(new Set(appointmentIds));
                                setMoveMenuOpen(false);
                            }}
                            onDropAppointments={(appointmentIds, roomUnitId, label) => {
                                setMoveMenuOpen(false);
                                setPendingRoomMove({ roomUnitId, label, appointmentIds });
                            }}
                            onSelectMoveDestination={(roomUnitId, label) => {
                                setMoveMenuOpen(false);
                                setPendingRoomMove({ roomUnitId, label });
                            }}
                            onShowOrder={showOrderHandler}
                            onShowPet={showPetHandler}
                        />
                    ) : (
                        <AppointmentsListTable
                            list={filteredAndSortedList}
                            listType={props.listType}
                            selectedTabId={filter.tabId ?? ''}
                            isLoading={loading.list || loading.vehicles}
                            sorter={sorter}
                            sort={usesServerPagination ? serverSort : null}
                            scrollerContainerId={scrollerContainerId}
                            pagination={pagination}
                            serverPagination={
                                usesServerPagination
                                    ? {
                                          page: pagination.page,
                                          pageSize: pagination.pageSize,
                                          totalPages: Math.max(serverPaginationInfo.totalPages, 1)
                                      }
                                    : undefined
                            }
                            onCheckout={(bookingId, orderId) => checkoutHandler(bookingId, orderId, false)}
                            onShowOrder={showOrderHandler}
                            onEditRequested={(bookingId, orderId) => showOrderHandler(bookingId, orderId, true)}
                            onShowClient={showClientHandler}
                            onShowPet={showPetHandler}
                            onChangeRoomUnit={changeRoomUnitHandler}
                            onRequestedStatusChanged={() => refetch()}
                            onAddReport={addReportHandler}
                            onViewReport={viewReportHandler}
                            onSort={sortHandler}
                            onServerSort={usesServerPagination ? serverSortHandler : undefined}
                            onStaffChangeSaved={staffChangeSavedHandler}
                            onChangePagination={paginationChangeHandler}
                            selectedIds={supportsBulkSelection ? selectedAppointmentIds : undefined}
                            onToggleSelect={supportsBulkSelection ? toggleSelectAppointmentHandler : undefined}
                            onToggleSelectAll={supportsBulkSelection ? toggleSelectAllHandler : undefined}
                        />
                    )}
                    {supportsBulkSelection && selectedAppointments.length > 0 && (
                        <BulkActionsToolbar
                            selectedCount={selectedAppointments.length}
                            actions={commonBulkStatusActions}
                            scrollerContainerId={scrollerContainerId}
                            moveMenu={
                                isDaycareKanban && moveMenuOpen ? (
                                    <KanbanMoveDestinationMenu
                                        appointments={list}
                                        onClose={() => setMoveMenuOpen(false)}
                                        onSelect={(roomUnitId, label) => {
                                            setMoveMenuOpen(false);
                                            setPendingRoomMove({ roomUnitId, label });
                                        }}
                                    />
                                ) : undefined
                            }
                            onMove={isDaycareKanban ? () => setMoveMenuOpen(prev => !prev) : undefined}
                            onClear={clearSelection}
                            onSelectStatus={selectBulkStatusHandler}
                        />
                    )}
                </div>
            </div>
            {pendingRoomMove && (
                <BulkChangeStatusConfirmDialog
                    open={true}
                    title="Change Room"
                    appointmentsCount={roomMoveAppointments.length}
                    currentStatusLabels={Array.from(
                        new Set(
                            roomMoveAppointments.map(app =>
                                app.room?.unit?.id != null ? `${app.room.name} (${app.room.unit.name})` : 'Unassigned'
                            )
                        )
                    )}
                    newStatusLabel={pendingRoomMove.label}
                    processing={movingRooms}
                    onCancel={() => {
                        if (!movingRooms) {
                            setPendingRoomMove(null);
                        }
                    }}
                    onConfirm={confirmRoomMoveHandler}
                />
            )}
            {pendingBulkStatusChange?.step === 'summary' && (
                <BulkChangeStatusConfirmDialog
                    open={true}
                    appointmentsCount={selectedAppointments.length}
                    currentStatusLabels={selectedAppointmentsCurrentStatusLabels}
                    newStatusLabel={pendingBulkStatusChange.statusName}
                    processing={appointmentsStatus === AppointmentsStatus.BulkUpdatingStatus}
                    onCancel={cancelBulkStatusChangeHandler}
                    onConfirm={confirmBulkSummaryHandler}
                />
            )}
            {pendingBulkStatusChange?.step === 'cancelation' && selectedAppointments[0] && (
                <PopUpCancelAppointment
                    loading={appointmentsStatus === AppointmentsStatus.BulkUpdatingStatus}
                    appointmentId={selectedAppointments[0].appointmentId}
                    customerFirstName={selectedAppointments[0].customer.firstName}
                    customerLastName={selectedAppointments[0].customer.lastName}
                    initCancelationReasonId={
                        pendingBulkStatusChange.statusId === appointmentStatuses.NO_SHOW ? reasonNoShowId : undefined
                    }
                    initSendNotification={pendingBulkStatusChange.statusId === appointmentStatuses.CANCELLED}
                    onClose={cancelBulkStatusChangeHandler}
                    onConfirmCancel={confirmBulkStatusChangeHandler}
                    onConfirmCancelRecurrent={confirmBulkStatusChangeHandler}
                    zIndex={10300}
                />
            )}
            {showOrder && rightPanelView === 'booking_detail' && (
                <OrderDetail
                    orderId={showOrder.orderId!}
                    bookingId={showOrder.bookingId!}
                    onClose={closeOrderHandler}
                    onOrderUpdated={refetch}
                    onCheckout={(bookingId, orderId) => checkoutHandler(bookingId, orderId, true)}
                    onRebookOrder={closeOrderHandler}
                    onRebookService={closeOrderHandler}
                    onShowActivityLog={() => setRightPanelView('activity_log')}
                    onViewResults={evaluationReport => {
                        if (evaluationReport) setEvaluationReportToView(evaluationReport);
                    }}
                    startInEditMode={showOrder.startInEditMode}
                    zIndex={props.overlayZIndex ?? (props.clientId || props.petId ? 10100 : undefined)}
                />
            )}
            {showOrder && rightPanelView === 'activity_log' && (
                <BookingActivityLog
                    bookingId={showOrder.bookingId!}
                    onClose={() => setRightPanelView('booking_detail')}
                    onPanelClose={closeOrderHandler}
                    zIndex={props.overlayZIndex ?? (props.clientId || props.petId ? 10100 : undefined)}
                />
            )}
            {showCheckout && (
                <Checkout
                    orderId={showCheckout.orderId}
                    bookingId={showCheckout.bookingId}
                    onClose={closeCheckoutHandler}
                    onViewBooking={closeCheckoutHandler}
                    onPayByLinkSent={closeCheckoutHandler}
                    onBack={closeCheckoutHandler}
                    onEditClient={showClientHandler}
                    hide={showCheckout?.hide}
                    zIndex={props.overlayZIndex ?? (props.clientId || props.petId ? 10100 : undefined)}
                />
            )}

            {showClient.show && (
                <OverFullWindow
                    onClose={closeClientHandler}
                    className={styles.clientOverFullWindow}
                >
                    <Client
                        hideHeader={true}
                        clientId={showClient.clientId}
                        isNewBooking={showClient.isNewBooking}
                        onClose={closeClientHandler}
                        onClientSaved={savedClientHandler}
                        onPetSaved={savedClientPetHandler}
                        onDelete={closeClientHandler}
                    />
                </OverFullWindow>
            )}

            {showPet && (
                <PetCard
                    petId={showPet.petId}
                    onSaved={savedPetHandler}
                    onClose={closePetHandler}
                />
            )}

            {showNewBooking.show && (
                <CreateBookingDrawer
                    parentID={showNewBooking.savedClientId}
                    petID={showNewBooking.savedPetId}
                    isEvaluation={showNewBooking.type === 'evaluation'}
                    isDaycareFastCheckIn={showNewBooking.type === 'fastCheckIn'}
                    flow={showNewBooking.type === 'booking' ? getFlowFromListType(props.listType) : undefined}
                    showTabs={false}
                    clientAdded={showNewBooking.savedClientId !== undefined}
                    petAdded={showNewBooking.savedPetId !== undefined}
                    zIndex={props.overlayZIndex}
                    onAddClient={addNewClient}
                    onAddPet={addNewPet}
                    onClose={closeNewBookingHandler}
                    onBooked={() => {
                        closeNewBookingHandler();
                        refetch();
                    }}
                    onRefreshBooking={() => refetch()}
                    onViewResults={evaluationReport => {
                        if (evaluationReport) setEvaluationReportToView(evaluationReport);
                    }}
                    //onRemoveClient={handleRemoveClient}
                />
            )}

            {evaluationReportToView && (
                <EvaluationReportDrawer
                    evaluationReport={evaluationReportToView}
                    petId={evaluationReportToView.petId}
                    defaultViewMode="view"
                    zIndex={(props.overlayZIndex ?? 10002) + 100}
                    onClose={() => setEvaluationReportToView(null)}
                />
            )}

            {addReport !== null && (
                <OverDetail>
                    <CompleteReport
                        appointmentId={addReport.appointmentId}
                        businessAreaId={addReport.businessArea}
                        emailConfigured={addReport.clientHasEmail}
                        onBack={backReportHandler}
                        onClose={closeReportHandler}
                        declined={false}
                        onlyAddReport={true}
                    />
                </OverDetail>
            )}

            {viewReport !== null && (
                <OverDetail>
                    <ViewReport
                        appointmentId={viewReport.appointmentId!}
                        businessAreaId={viewReport.businessArea}
                        onBack={backReportHandler}
                        onClose={closeReportHandler}
                        emailConfigured={viewReport.clientHasEmail}
                        onEditGrooming={() => editReportHandler(viewReport.appointmentId)}
                        onEditDental={() => editReportHandler(viewReport.appointmentId)}
                    />
                </OverDetail>
            )}

            {editReport !== null && (
                <OverDetail>
                    <EditReport
                        emailConfigured={editReport.clientHasEmail}
                        appointmentId={editReport.appointmentId}
                        businessAreaId={editReport.businessArea}
                        savePDF={true}
                        onBack={backReportHandler}
                        onClose={closeReportHandler}
                        onView={() => viewReportHandler(editReport.appointmentId)}
                        declined={false}
                    />
                </OverDetail>
            )}
        </>
    );
};

export default AppointmentsList;
